"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getInfoIconUtilityClass = getInfoIconUtilityClass;
var _mui = require("@ori-ui/mui");
function getInfoIconUtilityClass(slot) {
  return (0, _mui.generateUtilityClass)('InfoIcon', slot);
}
const infoIconClasses = (0, _mui.generateUtilityClasses)('InfoIcon', ['root', 'autoResize', 'contentIcon', 'contentText', 'contentAutoResize']);
var _default = exports.default = infoIconClasses;
